export default __webpack_public_path__ + "static/ASDMlogo-30665cd30fe84e88b6ccfdf4d7a55296.png";